var React = require('react');

function MyProfileInshuredIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","style":{"fill":"none"},"key":0}),React.createElement("g",{"id":"_01_align_center","key":1},[React.createElement("path",{"id":"Path_6996","d":"M10,19h-.3c-.3-.2-7.2-3.4-7.2-9v-4.9c0-1,.6-1.8,1.5-2.1l6-2,6,2c.9.3,1.5,1.2,1.5,2.1v4.9c0,6.5-7,8.9-7.3,9h-.3ZM10,2.5l-5.5,1.8c-.3.1-.5.4-.5.7v4.9c0,4.1,4.9,6.8,6.1,7.4,1.2-.5,6-2.7,6-7.4v-4.9c0-.3-.2-.6-.5-.7l-5.5-1.8Z","style":{"fill":"#5b6070"},"key":0}),React.createElement("path",{"id":"Path_6997","d":"M9.3,11.9h0c-.4,0-.8-.2-1-.5l-1.7-1.8,1.1-1,1.7,1.8,3.9-3.9,1.1,1.1-4,4c-.3.3-.6.4-1,.4Z","style":{"fill":"#5b6070"},"key":1})])]);
}

MyProfileInshuredIcon.defaultProps = {"id":"Layer_1","width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = MyProfileInshuredIcon;

MyProfileInshuredIcon.default = MyProfileInshuredIcon;
